/**
 * Service notices — admin-written known-issue messages (apps/api routes/service-notices.ts).
 * Reading the banner is open to everyone signed in; managing notices is admin-only.
 */

import { apiGet, apiPost, apiPut, apiDelete } from '../client.js';

/** Active notices + those resolved in the last 24 hours. */
export const getServiceNotices = () => apiGet('/api/service-notices');

/** Admin: every notice. */
export const getAllServiceNotices = () => apiGet('/api/service-notices/all');

/** Admin: create (no id) or update a notice. */
export const saveServiceNotice = (notice) =>
  notice.id
    ? apiPut(`/api/service-notices/${encodeURIComponent(notice.id)}`, { body: notice })
    : apiPost('/api/service-notices', { body: notice });

export const resolveServiceNotice = (id, note, notify = true) =>
  apiPost(`/api/service-notices/${encodeURIComponent(id)}/resolve`, { body: { note, notify } });

export const reopenServiceNotice = (id) => apiPost(`/api/service-notices/${encodeURIComponent(id)}/reopen`);

export const deleteServiceNotice = (id) => apiDelete(`/api/service-notices/${encodeURIComponent(id)}`);
